import React from 'react'
import BkgImg from 'gatsby-background-image'
import Img from 'gatsby-image'
import Player from '@vimeo/player'
import ReactPlayer from 'react-player'
import Tippy from '@tippyjs/react'
import { Waypoint } from 'react-waypoint'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away-extreme.css'

import ScrollToRead from './scrollToRead'
import SoundButton from './soundButton'

import heroStyles from './hero.module.scss'

class Hero extends React.Component {
  constructor(props) {
    super(props)

    this.setMute = this.setMute.bind(this)
    this.updateTimeElapsed = this.updateTimeElapsed.bind(this)

    this.state = {
      enableWaypoint: false,
      muted: true,
      allowUnmute: false,
      videoProgress: 0,
      showAudioTooltip: false,
      disableAudioTooltip: false,
      videoReady: false,
    }
  }

  updateTimeElapsed(e) {
    this.setState({
      videoProgress: e.played,
    })
  }

  setMute(muted, byUser) {
    //se o usuário tira o mudo, permite que o Waypoint tire também
    if (byUser === true) {
      this.setState({ allowUnmute: muted === false })
    }

    if (this.state.player) {
      this.setState({
        muted,
        showAudioTooltip: false,
        disableAudioTooltip: true,
      })
      this.state.player.setMuted(muted)
    }
  }

  titleSizeClass = title => {
    if (title.length < 30) {
      return heroStyles.h1_xg
    } else if (title.length < 70) {
      return heroStyles.h1_lg
    } else {
      return ''
    }
  }

  makeBigTitle = title => {
    const bigtitle = title.split(':')
    if (bigtitle.length > 1) {
      return (
        <>
          <span className={heroStyles.bigger}>{`${bigtitle[0]}:`}</span>
          <span>{bigtitle[1]}</span>
        </>
      )
    } else {
      return <span>{this.state.titleText}</span>
    }
  }

  render() {
    const { article, forceMute } = this.props
    const videoId = article.cover_video_id

    return (
      <Waypoint
        key={`hero-${article.id}`}
        onEnter={() => {
          if (
            this.state.enableWaypoint &&
            this.state.allowUnmute &&
            forceMute === false
          ) {
            this.setMute(false)
          }
        }}
        onLeave={() => {
          this.setState({ enableWaypoint: true })
          this.setMute(true)
        }}
        bottomOffset="20%"
      >
        <header className={`clearfix ${heroStyles.header}`}>
          <ReactPlayer
            className={heroStyles.heroPlayer}
            url={`https://vimeo.com/${videoId}`}
            onReady={e => {
              e.player.player.player.element.tabIndex = -1
              const player = new Player(e.player.player.player.element)
              this.setState({ player, videoReady: true })
            }}
            onPlay={e => {
              this.state.player
                .getMuted()
                .then(muted => {
                  this.setState({
                    muted,
                    showAudioTooltip: true,
                  })
                })
                .catch(function(error) {
                  console.warn(error)
                })
              this.setState({ videoProgress: 10 })
            }}
            muted={true}
            loop={true}
            width="100%"
            height="100%"
            playsinline={true}
            playing
          />

          {/* BACKGROUND-IMAGE */}
          {article.cover_image && (
            <div
              className={`${heroStyles.bkgImgContainer} ${
                this.state.videoReady ? heroStyles.bkgImgContainer__hidden : ''
              }`}
            >
              <Img
                className={heroStyles.bkgImg}
                fluid={article.cover_image.childImageSharp.fluid}
              />
              {/* <BkgImg
                className={heroStyles.bkgImg}
                fluid={article.cover_image.childImageSharp.fluid}
              /> */}
            </div>
          )}

          <div className={heroStyles.shader}></div>

          <div className={`container ${heroStyles.soundContainer}`}>
            <Tippy
              content="Habilite o áudio para uma experiência mais completa"
              animation="shift-away-extreme"
              visible={this.state.showAudioTooltip}
              disabled={this.state.disableAudioTooltip}
              maxWidth={200}
              delay={[1000, 0]}
            >
              <span
                role="button"
                tabIndex="0"
                onMouseEnter={() => this.setState({ showAudioTooltip: true })}
                onMouseLeave={() => this.setState({ showAudioTooltip: false })}
              >
                <SoundButton
                  className={heroStyles.soundButton}
                  muted={this.state.muted}
                  videoReady={this.state.videoReady}
                  onClick={() => {
                    this.setMute(!this.state.muted, true)
                  }}
                />
              </span>
            </Tippy>
          </div>

          {/* TITLE, LEAD AND STUFF */}
          {this.state.titleText ? (
            <div className={`container ${heroStyles.titleContainer}`}>
              <h1
                className={`${heroStyles.h1} ${this.titleSizeClass(
                  this.state.titleText
                )}`}
              >
                {article.num_chapter === 0 ? (
                  this.makeBigTitle(this.state.titleText)
                ) : (
                  <span>{this.state.titleText}</span>
                )}
              </h1>
              <div className={heroStyles.leadBlock}>
                <p className={`${heroStyles.lead}`}>{article.lead}</p>
                <ScrollToRead classes={`${heroStyles.cta}`} />
              </div>
            </div>
          ) : (
            ''
          )}
        </header>
      </Waypoint>
    )
  }

  componentDidMount() {
    const titleText =
      this.props.article.formated_title || this.props.article.title
    this.setState({ titleText })
  }
}

export default Hero
